import { useMutation } from '@apollo/client'
import CreateProjectStatusChangeReasonMutation from '~/use-cases/project/project-status-change-reason/create-project-status-change-reason.graphql'

export const useCreateProjectStatusChangeReason = () => {
  return useMutation(CreateProjectStatusChangeReasonMutation)
}
